'use strict';

const { alertMessage } = require('../common/common');

var SELECTORS = {
    element: '.js-order-detail',
    elementDefault: '.js-order-detail',
    refundButton: '.js-refund-action',
    detailButton: '.js-detail-action',
    form: '#returnForm',
    // formDefault: '#returnForm',
    submitRefund: '.js-submit-refund',
    refundCheckbox: '.js-refund-product-checkbox',
    openModalBtn: '.js-return-open-modal',
    confirmReturnModal: '#confirmCreateReturnModal'
};

var elementsChanged = false;

const MODES = {
    refund: 'refund',
    detail: 'detail',
    disabled: 'disabled'
}

class OrderDetail {
    constructor(element) {
        this.element = $(element);
        this.initEvents();
    }

    initEvents() {
        this.onRefundClick();
        this.onSubmit();
        this.onChange();
        this.showReturnCaseAlert();
    }

    /**
     * Handles the click event on the refund button
     */
    onRefundClick() {
        $(SELECTORS.refundButton).on('click', (e) => {
            e.preventDefault();
            var elementFound = $(e.target);
            let shippingOrderNumber = elementFound.data('shippingorderno') || '';
            if (shippingOrderNumber && shippingOrderNumber != '') {
                e.stopImmediatePropagation();
            } else {
                e.stopPropagation();
            }
            
            if (shippingOrderNumber && shippingOrderNumber != '' && !elementsChanged) {
                // SELECTORS.element = SELECTORS.element + '-' + shippingOrderNumber;
                // SELECTORS.form = SELECTORS.form + '-' + shippingOrderNumber;
                SELECTORS.element = '[data-shippingorderno="' + shippingOrderNumber + '"]';
                this.element = $(SELECTORS.element);
                elementsChanged = true;
            }
            
            this.togglePageMode(MODES.refund);

            this.siblingElements = $(SELECTORS.element).siblings(SELECTORS.elementDefault);
            this.siblingElements.each(function () {
                new OrderDetail(this).togglePageMode(MODES.disabled);
            });
        });

        $(SELECTORS.detailButton).on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            var $form = $('#returnForm');
            if ($form.hasClass('has-multi-shipping')) {
                SELECTORS.element = SELECTORS.elementDefault;
                // SELECTORS.form = SELECTORS.formDefault;
                elementsChanged = false;
            }
            this.siblingElements = $(SELECTORS.element).siblings(SELECTORS.elementDefault);
            this.siblingElements.each(function () {
                new OrderDetail(this).togglePageMode(MODES.detail);
            });
            this.togglePageMode(MODES.detail);
        });
    }

    /**
     * Toggles the page mode between refund and detail
     * @param {string} mode
     */
    togglePageMode(mode) {
        this.element.attr('data-mode', mode);
    }

    /**
     * Handles submit form
     */
    onSubmit() {
        $(SELECTORS.form).on('submit', async function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $.spinner().start();
            var $form = $(this);
            var url = $form.attr('action');
            let shippingOrderNumber = $(SELECTORS.element).data('shippingorderno') || '';
            var body = buildBody($form.serializeArray(), shippingOrderNumber);

            //VALIDATE FORM
            let validationError = validateForm(body.formList, shippingOrderNumber);
            if (validationError) {
                $.spinner().stop();
                $(SELECTORS.confirmReturnModal).modal('hide');
                return;
            }

            //BUILD FORM DATA
            let orderNumber = $(SELECTORS.element).data('orderno');
            
            var formdata = new FormData();
            formdata.append('orderNumber', orderNumber);
            if (shippingOrderNumber && shippingOrderNumber != '') {
                formdata.append('shippingOrderNumber', shippingOrderNumber);
            }
            formdata.append('formList', JSON.stringify(body.formList));

            // CALL API
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    body: formdata,
                });

                const data = await response.json();

                if (response.status === 200) {
                    if (!data.success) {
                        alertMessage(data.msg, 'cc-alert--danger');
                    } else {
                        alertMessage(data.msg, 'cc-alert--success');
                    }

                    var currentUrl = window.location.href;
                    var newUrl = removeUrlParameter(currentUrl, 'pageMode');
                    if(newUrl.indexOf('&createReturn=true') > -1){
                        newUrl = newUrl.replace('&createReturn=true', '&createReturn=false');
                    }
                    if(newUrl.indexOf('&returnConfirmed=true') > -1){
                        window.location.href = `${newUrl}`;
                    } else {
                        window.location.href = `${newUrl}&returnConfirmed=true`;
                    }
                } else {
                    $.spinner().stop();
                    alertMessage(data.msg, 'cc-alert--danger');
                }

            } catch (error) {
                console.error(error);
                $.spinner().stop();
            }
        });
    }

    /**
     * Handles error form and confirm refund button
     */
    onChange() {
        //CHECK FORM ERROR
        $('select').on('change', function () {
            var $select = $(this);
            let id = $select.attr('id')
            if ($select.val() > 0) {
                $('#' + id + '-error').removeClass('d-block');
            }
        })

        // ENABLE/DISABLE CONFIRM BUTTON
        $(SELECTORS.refundCheckbox).on('change', function () {
            if ($(this).is(':checked')) {
                $(SELECTORS.submitRefund).prop('disabled', false);
                $(SELECTORS.openModalBtn).prop('disabled', false);
                handleSelectsVisibility($(this).val(), 'show');
            } else {
                let isAnyChecked = $(SELECTORS.refundCheckbox).is(':checked');
                $(SELECTORS.submitRefund).prop('disabled', !isAnyChecked);
                $(SELECTORS.openModalBtn).prop('disabled', !isAnyChecked);
                let uuid = $(this).val();
                $(`.invalid-feedback-${uuid}`).removeClass('d-block');
                handleSelectsVisibility($(this).val(), 'hide');
            }
        });
    }

    showReturnCaseAlert(){
        customAlertMessage($(SELECTORS.element).data('returnsuccess'), 'cc-alert--success', false);
    }
}


/**
    HELPERS
*/
function buildBody(array, shippingOrderNumber) {
    let orderNumber = $(SELECTORS.element).data('orderno');
    let body = {
        orderNumber: orderNumber,
        formList: []
    }
    if (shippingOrderNumber && shippingOrderNumber != '') {
        array.forEach(el => {
            if (el.name.includes('refund-lineItem') && el.name.includes(shippingOrderNumber)) {
                // let reason = $(`#refund-${el.value}-${shippingOrderNumber}-reason`).val();
                let reason = $(`select[data-reason="refund-${el.value}-${shippingOrderNumber}-reason"]`).val();
                // let quantity = $(`#refund-${el.value}-${shippingOrderNumber}-quantity`).val();
                let quantity = $(`select[data-quantity="refund-${el.value}-${shippingOrderNumber}-quantity"]`).val();
                let obj = { itemQty: quantity, uuid: el.value, reasonCode: reason }
                body.formList.push(obj);
            }
        });
    } else {
        array.forEach(el => {
            if (el.name.includes('refund-lineItem')) {
                let reason = $(`#refund-${el.value}-reason`).val();
                let quantity = $(`#refund-${el.value}-quantity`).val();
                let obj = { itemQty: quantity, uuid: el.value, reasonCode: reason }
                body.formList.push(obj);
            }
        });
    }
    return body;
}

function validateForm(form, shippingOrderNumber) {
    let error = false
    if (shippingOrderNumber && shippingOrderNumber != '') {
        form.forEach(el => {
            if (el.reasonCode <= 0) {
                $('#refund-' + el.uuid + '-' + shippingOrderNumber + '-reason-error').addClass('d-block');
                error = true;
            }
            if (el.itemQty <= 0) {
                $('#refund-' + el.uuid + '-' + shippingOrderNumber + '-quantity-error').addClass('d-block');
                error = true;
            }
        });
    } else {
        form.forEach(el => {
            if (el.reasonCode <= 0) {
                $('#refund-' + el.uuid + '-reason-error').addClass('d-block');
                error = true;
            }
            if (el.itemQty <= 0) {
                $('#refund-' + el.uuid + '-quantity-error').addClass('d-block');
                error = true;
            }
        });
    }    
    return error;
}

function handleSelectsVisibility(uuid, action) {
    let reasonSelect = $(`.uuid-${uuid}-wrapper .js-dynamic-reason-select`);
    let quantitySelect = $(`.uuid-${uuid}-wrapper .js-dynamic-qty-select`);
    if (action == 'show') {
        reasonSelect.removeClass('d-none')
        quantitySelect.removeClass('d-none')
    }
    if (action == 'hide') {
        reasonSelect.addClass('d-none')
        quantitySelect.addClass('d-none')
    }
}

function removeUrlParameter(url, parameter) {
    // Split the URL into parts
    var urlParts = url.split('?');

    if (urlParts.length >= 2) {
        // Get the parameters part of the URL
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlParts[1].split(/[&;]/g);

        // Create a new parameters array excluding the parameter to remove
        for (var i = pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        // Reconstruct the URL without the parameter
        url = urlParts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
    }
    return url;
}


/**
 * Display an alert message (custom return version)
 * @param {String} $text - Text to display
 * @param {String} $class - Class to add to the alert
 * @param {Boolean} enableTimeout - Whether to auto-dismiss after timeout
 */
function customAlertMessage($class, enableTimeout) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('returnConfirmed') === 'true') {
        const successTimeout = 4000;
        const dangerTimeout = 6000;
        let timeout = successTimeout;

        const $alert = $('.js-alert-return');
        const $alertMessage = $('.js-alert-message-return');

        let lastFocusedElement = null;

        const originalText = $alertMessage.text().trim();

        if (originalText !== '') {
            // Save current focus (keyboard users only)
            if (!$('body').hasClass('using-mouse') && !$(document.activeElement).closest('.js-overlay, .modal, .cc-overlay').length) {
                lastFocusedElement = document.activeElement;
            }

            // Update message content immediately to trigger aria-live
            $alertMessage.empty().text(originalText);

            // Show the alert and make it accessible
            $alert
                .removeClass('cc-active') // reset state
                .removeClass('cc-alert--danger cc-alert--success cc-alert--info') // remove old types
                .addClass($class)
                .addClass('cc-active')
                .attr('aria-hidden', 'false')
                .attr('tabindex', '0');

            // Move focus to alert for screen reader
            if (lastFocusedElement && !$('body').hasClass('using-mouse')) {
                $alert.focus();
            }

            // Set appropriate timeout
            if ($class === 'cc-alert--danger') {
                timeout = dangerTimeout;
                $alert.find('.js-alert-error-icon').removeClass('d-none');
                $alert.find('.js-alert-check-icon').addClass('d-none');
            } else {
                $alert.find('.js-alert-error-icon').addClass('d-none');
                $alert.find('.js-alert-check-icon').removeClass('d-none');
            }

            const hideAlert = () => {
                $alert
                    .removeClass($class)
                    .removeClass('cc-active')
                    .attr('aria-hidden', 'true')
                    .attr('tabindex', '-1');

                if (lastFocusedElement && typeof lastFocusedElement.focus === 'function' && document.body.contains(lastFocusedElement)) {
                    lastFocusedElement.focus();
                }
            };

            if (enableTimeout) {
                setTimeout(hideAlert, timeout);
            }
        }
    }
    if (urlParams.get('canCreateReturn') === 'true') {
        const successTimeout = 3000;
        const dangerTimeout = 6000;
        let timeout = successTimeout;


        $('.js-alert-can-create-return').addClass($class).removeClass('cc-active').addClass('cc-active').attr('aria-hidden', 'false').attr('tabindex', '0');

        if ($('.js-alert-can-create-return').hasClass('cc-alert--danger')) {
            timeout = dangerTimeout;
        }

        setTimeout(() => {
            $('.js-alert-can-create-return').removeClass($class).removeClass('cc-active').attr('aria-hidden', 'true').attr('tabindex', '-1');
        }, timeout);

        $('.js-close-alert-return').off('click').on('click', () => {
            $('.js-alert-can-create-return').removeClass($class).removeClass('cc-active').attr('aria-hidden', 'false').attr('tabindex', '0');
        });
    }
}


module.exports = () => {
    $(SELECTORS.element).each((index, element) => {
        new OrderDetail(element);
    });
};
